import type { AdminConfigResponse } from '@/api/types/user'

import { sliceApi } from './api'

const configSliceApi = sliceApi
  .enhanceEndpoints({ addTagTypes: ['Config'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getConfig: builder.query<AdminConfigResponse, void>({
        query: () => '/admin/config',
        providesTags: ['Config'],
      }),
    }),
    overrideExisting: false,
  })

export const { useGetConfigQuery } = configSliceApi
